export default {"src":"/_next/static/media/icon-linkedin-blue.3b99f32a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};